import { CommentMedia, CustomMedia } from "./CommentMedia";
import { useContext } from "react";
import { ProfileContext } from "../../context/profile";

export default function CommentBody({ comments, id }) {
  const { profile } = useContext(ProfileContext);

  return (
    <>
      <CustomMedia commentCount={comments?.length} profile={profile} id={id} />
      {comments?.map((item, index) => (
        <CommentMedia
          key={index}
          commentAuthor={item.user.first_name + " " + item.user.last_name}
          commentBody={item.comment}
          timeAgo={item.created_date}
          image={item.user.image}
          commentId={item.id}
          id={id}
          replies={item?.sub_comments}
        />
      ))}
    </>
  );
}
